










































































    import Vue from "vue";
    import axios from "axios";
    import Loader from "@/components/Loader.vue";

    axios.interceptors.response.use(response => response.data);

    interface ModelError {
        key: string;
        message: string;
    }

    interface LoginPageModel {
        email: string;
        password: string;
        rememberMe: boolean;
        returnUrl: string;
        message: string;
    }

    declare const errors: ModelError[];
    declare const model: LoginPageModel;

    export default Vue.extend({
        name: "App",
        data() {
            // errors and model are global and defined in Login.cshtml
            const globalErrors = errors.filter(e => e.key === "");

            const xsrfTokenInput = document.getElementById("RequestVerificationToken");
            const token = xsrfTokenInput !== null ? (xsrfTokenInput as HTMLInputElement).value : null;

            return {
                valid: true,
                globalError: globalErrors.length > 0 ? globalErrors[0].message : null,
                validationRules: [(v: string) => !!v || "Необходимо заполнить данное поле."],

                email: model.email,
                password: "",
                rememberMe: model.rememberMe,
                returnUrl: model.returnUrl,
                xsrfToken: token,
                message: model.message,
                restorePassword: false,
                restoreFormValid: true,
                restoringEmail: "",
                restoreLoading: false,
                snackbar: {
                    show: false,
                    text: "",
                    color: "success"
                }
            };
        },
        components: {
            loader: Loader
        },
        methods: {
            submitForm(event: Event) {
                const valid = (this.$refs.loginForm as any).validate();
                if (!valid) {
                    event.preventDefault();
                    return false;
                }
            },
            restore() {
                this.restorePassword = true;
                (this.$refs.loginForm as any).resetValidation();
            },
            submitRestoringForm() {
                const valid = (this.$refs.restoreForm as any).validate();
                if (!valid) {
                    return;
                }

                this.restoreLoading = true;
                const promise = axios.post("/api/User/RestorePassword", { emailOrLogin: this.restoringEmail }, {
                    headers: { RequestVerificationToken: this.xsrfToken }
                });

                promise.then((response: any) => {
                    this.restoreLoading = false;

                    if (response.isValid) {
                        this.cancelRestoring();
                        this.showNotification(false, {
                            text: "На ваш Email было отправлено письмо. Для восстановления пароля откройте это письмо.",
                            type: "success"
                        });
                        return;
                    }

                    if (!response.isValid) {
                        const failMessage = response.reasons && response.reasons.length > 0
                            ? response.reasons[0] : "Не удалось восстановить пароль";
                        this.showNotification(false, {
                            text: failMessage,
                            type: "error"
                        });
                    }
                }).catch(() => {
                    this.restoreLoading = false;
                    this.showNotification(false, {
                        text: "Не удалось восстановить пароль",
                        type: "error"
                    });
                });
            },
            cancelRestoring() {
                this.restorePassword = false;
                this.restoringEmail = "";
                (this.$refs.restoreForm as any).resetValidation();
            },
            showNotification(immediately: boolean, notification: any) {
                this.snackbar.text = notification.text;
                this.snackbar.color = notification.type;

                if (immediately) {
                    this.snackbar.show = true;
                } else {
                    this.$nextTick(() => this.snackbar.show = true);
                }
            }
        }
    });
